import { Target, Sparkle, HandHeart } from '@phosphor-icons/react';
import { PageHeader } from '../components/PageHeader';
import { RevealOnScroll } from '../components/motion/RevealOnScroll';
import { SpotlightCard } from '../components/motion/SpotlightCard';

const values = [
  {
    icon: Target,
    title: 'Built around one annoyance',
    body: 'Nobody enjoys writing "just following up on this" for the third time. We built Chase it for me to make that job disappear.',
  },
  {
    icon: Sparkle,
    title: 'Small team, sharp focus',
    body: 'We’re a small team obsessed with one workflow: chasing replies. No sprawling feature set, just a tool that does the one thing well.',
  },
  {
    icon: HandHeart,
    title: 'Your inbox, your rules',
    body: 'You stay in control of every follow-up. We just handle the tedious, repetitive parts so you don’t have to.',
  },
];

export function AboutPage() {
  return (
    <>
      <PageHeader
        eyebrow="About us"
        title="We built the assistant we wished existed"
        subtitle="Chase it for me started as a fix for our own inboxes, chasing invoices, replies, and updates we kept forgetting to follow up on."
      />

      <section className="py-8 pb-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid gap-5 sm:grid-cols-3">
            {values.map((value) => (
              <RevealOnScroll key={value.title}>
                <SpotlightCard className="h-full rounded-xl border border-white/10 bg-white/[0.04] p-6 hover:border-white/20 transition-colors duration-300">
                  <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-indigo-500/15">
                    <value.icon weight="bold" className="h-5 w-5 text-indigo-300" />
                  </div>
                  <h3 className="mt-4 font-semibold text-zinc-100 text-lg">{value.title}</h3>
                  <p className="mt-2 text-sm text-zinc-400">{value.body}</p>
                </SpotlightCard>
              </RevealOnScroll>
            ))}
          </div>

          <RevealOnScroll className="mt-16 max-w-3xl mx-auto text-center">
            <p className="text-zinc-400 text-lg">
              We’re still early, and we’re building in the open. If you have feedback on how Chase it for
              me could work better for you, we want to hear it.
            </p>
          </RevealOnScroll>
        </div>
      </section>
    </>
  );
}
